
import "./index.css";




const NaveBareTop = () => {
  return (
   <div className="header">
       <div className="left"></div>
       <div className="right">
       </div>
   </div>
  )
}

export default NaveBareTop
